import React, { useState, useContext } from "react";
import AlertsItem from "ui/alerts/alerts-item";
import { SvgArrowRight } from "ui/svgs";
import { formatContextDate } from "lib/utils";

export default function AlertsByDate({
  date,
  alerts,
  setVideoUrl,
  activeAlert,
  setActiveAlert,
  latestAlertTime,
}) {
  const [active, setActive] = useState(true);
  const [height, setHeight] = useState("auto");
  const refContent = React.useRef<HTMLDivElement>(null);

  const toggleAccordion = () => {
    setActive(!active);
    setHeight(active ? "0px" : `${refContent.current?.scrollHeight}px`);
  };

  const rotate = active ? "rotate(90deg)" : "rotate(0)";

  return (
    <>
      {date !== "noGroup" && (
        <button
          className="flex items-center justify-between pt-3 pb-1 px-6 w-full font-semibold text-sm"
          onClick={toggleAccordion}
        >
          <span>{date}</span>
          <SvgArrowRight
            width="22"
            style={{ transform: rotate, transition: "all 0.2s linear" }}
            className="fill-neutral-500 mr-1"
          />
        </button>
      )}

      <div
        ref={refContent}
        className="overflow-hidden transition-max-height duration-100 ease-in"
        style={{ maxHeight: `${height}` }}
      >
        {alerts.map((alert) => {
          const isNewAlert =
            !!latestAlertTime && latestAlertTime < +alert.createdAt;
          return (
            <AlertsItem
              key={alert.id}
              alertId={alert.id}
              dataAlert={alert}
              setVideoUrl={setVideoUrl}
              activeAlert={activeAlert}
              setActiveAlert={(alert) => setActiveAlert(alert)}
              isNew={isNewAlert}
            />
          );
        })}
      </div>
    </>
  );
}
